export const timeline = {
  event: {
    minHeight: "16px",
  },
  horizontal: {
    eventContent: {
      padding: "{padding.8} 0",
    },
  },
  vertical: {
    eventContent: {
      padding: "0 {padding.8}",
    },
  },
  eventMarker: {
    size: "16px",
    borderRadius: "50%",
    borderWidth: "0",
    background: "{content.border.color}",
    borderColor: "{content.border.color}",
    content: {
      borderRadius: "50%",
      size: "0",
      background: "{content.border.color}",
      insetShadow: "none",
    },
  },
  eventConnector: {
    color: "{content.border.color}",
    size: "{border.width.2}",
  },
  extend: {
    ui: {
      eventConnector: {
        gap: "{gap.4}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-timeline-vertical .p-timeline-event-connector {
      margin-block: ${dt("timeline.ui.event.connector.gap")};
      padding-block: ${dt("timeline.ui.event.connector.gap")};
    }

    .p-timeline-horizontal .p-timeline-event-connector {
      margin-inline: ${dt("timeline.ui.event.connector.gap")};
      padding-inline: ${dt("timeline.ui.event.connector.gap")};
    }

    .p-timeline-no-opposite .p-timeline-event-opposite {
      display: none;
    }
  `,
};
